// 自身のアセット
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/sp/component.scss'
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/sp/images/tel_icon.svg'
// 子コンポーネント
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/sp/image_container/component'
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_card/sp/cta/component'
// 他コンポーネント
import 'PackWerkNurikaeSite/pages/companies/index/partials/clamp_text_with_link/component'
import 'PackWerkNurikaeSite/pages/companies/index/partials/star_rating/component'
import 'PackWerkNurikaeSite/pages/companies/index/partials/company_area_info/component'

// ホバーアニメーション処理
document.addEventListener('mouseover', (event) => {
  const companyLink = event.target.closest('.js-company-link')
  if (companyLink) {
    companyLink.classList.add('is-current')
  }
})

document.addEventListener('mouseout', (event) => {
  const companyLink = event.target.closest('.js-company-link')
  if (companyLink) {
    companyLink.classList.remove('is-current')
  }
})
